import { render, staticRenderFns } from "./view-rejection-reason.vue?vue&type=template&id=6c22ba4c"
import script from "./view-rejection-reason.vue?vue&type=script&lang=js"
export * from "./view-rejection-reason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports